var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "316.05 596.25 73.2 60.9",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328.2,652.1c-1.9,0-3.6-0.7-5-2.1c-1.4-1.4-2.1-3-2.1-5v-36.6c0-1.9,0.7-3.6,2.1-5c1.4-1.4,3-2.1,5-2.1h48.9   c1.9,0,3.6,0.7,5,2.1c1.4,1.4,2.1,3,2.1,5v36.6c0,1.9-0.7,3.6-2.1,5c-1.4,1.4-3,2.1-5,2.1H328.2z M352.7,630.7l-24.5-15.4v29.8   h48.9v-29.8L352.7,630.7z M352.7,623.9l24.5-15.4h-48.9L352.7,623.9z M328.2,615.2v-6.7v36.6V615.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.db238cdebf3177a39920dd4e4c4a624c.svg";
export { ForwardRef as ReactComponent };